import { PREFERENCE_QUERY } from "@/gql/preference";
import { useBuyerStoreData } from "@/providers/global";
import { useUserPreferencesStore } from "@/stores/user-preferences";
import { useQuery } from "@apollo/client";
import { useEffect } from "react";

export function useUserPreferences() {
	const buyerId = useBuyerStoreData(state => state.buyerId);
	const { preferences: storePreferences, setPreferences, setLoading, setError } = useUserPreferencesStore();

	const { data, loading, error, refetch } = useQuery(PREFERENCE_QUERY, {
		variables: {
			params: {
				getBuyerPreferences: {
					groupId: buyerId,
				},
			},
		},
		skip: !buyerId,
	});

	// Sync loading state with store
	useEffect(() => {
		setLoading(loading);
	}, [loading, setLoading]);

	// Sync error state with store
	useEffect(() => {
		if (error) {
			setError(error.message);
		}
	}, [error, setError]);

	// Sync preferences
	useEffect(() => {
		setPreferences(data?.buyer?.getBuyerPreferences || []);
	}, [data?.buyer?.getBuyerPreferences, setPreferences]);

	const preferences = storePreferences.length > 0 ? storePreferences : data?.buyer?.getBuyerPreferences || [];

	return {
		preferences,
		loading,
		error,
		refetch,
	};
}
